export default __webpack_public_path__ + "4e2dd00af04f9b20a943b8b5987f9358.svg";